<template>
  <div class="documents-page">
    <el-dialog title="Создание документа" :visible.sync="createDialogVisible" width="600px" :close-on-click-modal="false">
      <div>
        <el-radio-group v-model="creationDocType">
          <el-radio-button v-for="ticket in ticketList" :key="ticket.key" :label="ticket.key">{{ ticket.title }}</el-radio-button>
        </el-radio-group>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="createDialogVisible = false">Отмена</el-button>
            <el-button type="primary" @click="createDocument">Сохранить</el-button>
      </span>
    </el-dialog>
    <breadcrumbs :company="companyDisplayName" :section="sectionLabel"></breadcrumbs>
    <div style="display: flex; justify-content: space-between">
      <h2 class="page-title">Документы <span class="page-subtitle">{{ sectionLabel.toLowerCase() }} · {{ typeLabel }}</span></h2>
      <div style="padding-right: 20px">
        <el-badge :value="notificantionCount" :max="99" class="item">
          <el-button disabled size="small" style="border-radius: 25px">Создано блоков</el-button>
        </el-badge>
      </div>
    </div>
    <el-card class="documents-page__filters" style="margin-bottom: 15px;">
      <div class="filters-row">
        <el-date-picker
            v-model="dateRange"
            type="daterange"
            align="right"
            unlink-panels
            range-separator="По"
            start-placeholder="Начало"
            end-placeholder="Конец"
            @change="getData"
            :picker-options="pickerOptions"
            :default-value="defaultDateRange"
            class="filters-row__date">
        </el-date-picker>
        <el-select v-model="searchKey" placeholder="Искать по" class="filters-row__select">
          <el-option
              v-for="item in searchKeys"
              :key="item.value"
              :label="item.label"
              :value="item.value">
          </el-option>
        </el-select>
        <el-input v-model="search" placeholder="Поиск" class="filters-row__search"></el-input>
        <el-button @click="getData" icon="el-icon-search">Искать</el-button>
        <el-button @click="getData" icon="el-icon-refresh">Обновить</el-button>
        <el-button v-if="canCreateTickets" @click="openCreateDocument" type="primary" icon="el-icon-plus">Создать документ</el-button>
      </div>
      <div class="filters-row filters-row--second">
        <button type="button" class="pending-chip" :class="{ 'pending-chip--active': onlyPending }" @click="togglePendingFilter">
          <i class="el-icon-time"></i> Ожидают подписания · {{ pendingCount }}
        </button>
      </div>
    </el-card>
    <el-card class="documents-card">
<!--      <div class="status-legend">-->
<!--        <el-tooltip content="Статусная модель документов" placement="top">-->
<!--          <span class="status-legend__icon">?</span>-->
<!--        </el-tooltip>-->
<!--        <span class="status-legend__title">Статусы:</span>-->
<!--        <status-badge status-name="Утвержден" status-color="success"></status-badge>-->
<!--        <span class="status-legend__hint">подписание не требуется</span>-->
<!--        <status-badge status-name="Утвержден" status-color="warning"></status-badge>-->
<!--        <span class="status-legend__hint">ожидает подписания на Портале</span>-->
<!--        <status-badge status-name="Подтвержден"></status-badge>-->
<!--        <span class="status-legend__hint">подписан контрагентом</span>-->
<!--        <status-badge status-name="Отредактирован"></status-badge>-->
<!--        <status-badge status-name="Отправлен"></status-badge>-->
<!--      </div>-->
      <div class="table-container">
        <el-table
            v-loading="isLoading"
            height="100%"
            :data="displayedData"
            @sort-change="sortChange"
            @row-click="openDocument($event)"
            :row-class-name="tableRowClassName"
            :default-sort="{}"
            size="small"
            style="width: 100%">
          <el-table-column
              prop="doctype"
              label="Тип документа"
          >
            <template slot-scope="scope">
              <span style="font-weight: bold">{{ scope.row.doctype }}</span>
            </template>
          </el-table-column>
          <el-table-column
              prop="docNumber"
              label="Номер"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.docNumber }}</span>
            </template>
          </el-table-column>
          <el-table-column
              v-if="isVu19 && isRoleKazykurt"
              prop="action"
              label="Действие"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.action || '—' }}</span>
            </template>
          </el-table-column>
          <el-table-column
              prop="documentId"
              label="ID документа"
              sortable
          >
            <template slot-scope="scope">
              <span>{{ scope.row.meta.documentId }}</span>
            </template>
          </el-table-column>
          <el-table-column
              prop="sendedAt"
              label="Дата отправки"
              sortable
          >
            <template slot-scope="scope">
              <span>{{ scope.row.created }}</span>
            </template>
          </el-table-column>
          <el-table-column
              prop="senderCompany"
              label="Отправитель"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.senderCompany }}</span>
            </template>
          </el-table-column>
          <el-table-column
              prop="receiverCompany"
              label="Получатель"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.receiverCompany }}</span>
            </template>
          </el-table-column>
          <el-table-column
              prop="statusName"
              label="Статус"
          >
            <template slot-scope="scope">
              <status-badge :status-name="scope.row.statusName" :status-color="scope.row.statusColor"></status-badge>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pagination">
        <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="currentPage"
            :page-sizes="[50, 100]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalElements"
        >
        </el-pagination>
      </div>
    </el-card>
  </div>
</template>

<script>
import blockchainApi from '@/modules/api/blockchain'
import authorizationAPI from '@/modules/api/authorization'
import date from '@/modules/directories/date/date'
import { canCreateTickets, getAllDocuments, getAllTickets } from '@/modules/permissions/permissions'
import { endOfDay, format, startOfMonth } from 'date-fns'
import * as permisson from '@/modules/permissions/permissions'
import StatusBadge from '@/components/StatusBadge'
import Breadcrumbs from '@/components/layout/Breadcrumbs'
import documentNotificationsStore from '@/modules/notifications/documentNotificationsStore'

export default {
  name: 'CompanyDocuments',
  components: {
    StatusBadge,
    Breadcrumbs
  },
  data () {
    const today = new Date()
    const currentYear = today.getFullYear()
    const currentMonth = today.getMonth()
    const firstDayOfCurrentMonth = new Date(currentYear, currentMonth, 1)
    const firstDayOfPreviousMonth = new Date(currentYear, currentMonth - 1, 1)
    const currentData = new Date()
    const fromDate = startOfMonth(currentData)
    const toDate = currentData
    return {
      isLoading: false,
      data: [],
      onlyPending: false,
      searchKey: 'docNumber',
      searchKeys: [
        { label: 'Номеру документа', value: 'docNumber' },
        { label: 'Номеру вагона', value: 'nomerVagona' }
      ],
      createDialogVisible: false,
      creationDocType: '',
      currentPage: 1,
      pageSize: 10,
      totalElements: 0,
      sortBy: '',
      orderBy: '',
      search: '',
      notificantionCount: 0,
      pickerOptions: {
        shortcuts: [{
          text: 'Неделя',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: 'Месяц',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '3 месяца',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
            picker.$emit('pick', [start, end])
          }
        }]
      },
      defaultDateRange: [firstDayOfPreviousMonth, firstDayOfCurrentMonth],
      value1: '',
      dateRange: [
        fromDate,
        toDate
      ],
      ticketList: []
    }
  },
  created () {
    this.pageSize = 50
  },
  mounted () {
    this.getData()
    this.getNotificationsCount()
    this.getTicketList()
  },
  computed: {
    isVu19 () {
      return this.getDocumentTypes.filter(i => i === 'vu19').length > 0
    },
    hasBinProps () {
      return this.$route.query.bin
    },
    getCompanyBin () {
      return authorizationAPI.getUsersCompanyBin()
    },
    canCreateTickets () {
      return canCreateTickets(authorizationAPI.getRole())
    },
    isRoleErtys () {
      return authorizationAPI.isRoleErtys()
    },
    isRoleKazykurt () {
      return authorizationAPI.isRoleKazykurt()
    },
    isRoleBatys () {
      return authorizationAPI.isRoleBatys()
    },
    getUsersCompanyBin () {
      return authorizationAPI.getUsersCompanyBin()
    },
    filteredData () {
      return this.data
    },
    getDocumentTypes () {
      if (this.$route.params.types) {
        return this.$route.params.types.split(',')
      }
      return []
    },
    isAllDocumentsView () {
      return !!this.$route.query.all
    },
    companyDisplayName () {
      return authorizationAPI.getCompanyDisplayName()
    },
    isSentSection () {
      const ticketKeys = this.ticketList.map(item => item.key)
      return this.getDocumentTypes.some(type => ticketKeys.includes(type))
    },
    sectionLabel () {
      return this.isSentSection ? 'Отправленные' : 'Полученные'
    },
    typeLabel () {
      const typesParam = this.$route.params.types || ''
      const docs = getAllDocuments()
      const ticks = getAllTickets()
      let documentsList = []
      for (const station in docs) {
        documentsList = documentsList.concat(docs[station])
        documentsList = documentsList.concat(ticks[station])
      }
      const match = documentsList.find(doc => doc.key === typesParam)
      return match ? match.title.toLowerCase() : 'все типы'
    },
    pendingCount () {
      return this.data.filter(item => item.statusName === 'Утвержден' && item.statusColor === 'warning').length
    },
    displayedData () {
      if (!this.onlyPending) return this.data
      return this.data.filter(item => item.statusName === 'Утвержден' && item.statusColor === 'warning')
    }
  },
  watch: {
    getDocumentTypes (val) {
      this.getData()
    }
  },
  methods: {
    togglePendingFilter () {
      this.onlyPending = !this.onlyPending
    },
    getTicketList () {
      if (this.isRoleErtys) {
        this.ticketList = permisson.getTicketsList('ERTYS')
      } else if (this.isRoleKazykurt) {
        this.ticketList = permisson.getTicketsList('KAZYKURT')
      } else if (this.isRoleBatys) {
        this.ticketList = permisson.getTicketsList('BATYS')
      }
    },
    getNotificationsCount () {
      blockchainApi.getNotificationsCount(this.getUsersCompanyBin).then(resp => {
        if (resp !== 0) {
          this.notificantionCount = resp
        }
      })
    },
    tableRowClassName ({ row, rowIndex }) {
      if (row.statusName === 'Отменен' || row.statusName === 'Отклонен') {
        return 'canceled-row'
      }
      if (row.data.body?.documentWorkplaceRailcar?.documentRailcar?.rejectingReason) {
        return 'error-row'
      }
      return ''
    },
    openCreateDocument () {
      this.createDialogVisible = true
      // if (this.$route.params.types.includes(',') || this.$route.params.types === 'vu20' || this.$route.params.types === 'act' || this.$route.params.types === 'vu20a' || this.$route.params.types === 'vu19') {
      //   this.createDialogVisible = true
      // } else {
      //   this.creationDocType = this.$route.params.types
      //   this.createDocument()
      // }
    },
    sortChange ({ column, prop, order }) {
      console.log(prop, order)
      this.sortBy = prop
      if (order && order.includes('asc')) {
        this.orderBy = 'asc'
      } else if (order && order.includes('desc')) {
        this.orderBy = 'desc'
      } else {
        this.orderBy = ''
        this.sortBy = ''
      }
      this.getData()
    },
    handleSizeChange (event) {
      this.pageSize = event
      this.getData()
      console.log(event)
    },
    handleCurrentChange (event) {
      this.currentPage = event
      this.getData()
      console.log(event)
    },
    getData () {
      this.getNotificationsCount()
      this.isLoading = true
      const fromDate = format(new Date(this.dateRange[0]), 'yyyy-MM-dd HH:mm:ss')
      const toDate = format(endOfDay(new Date(this.dateRange[1])), 'yyyy-MM-dd HH:mm:ss')
      let companyBin = this.hasBinProps ? this.hasBinProps : this.getCompanyBin
      if (authorizationAPI.isRoleBatysBtg()) {
        companyBin = '1911400253453'
      }
      blockchainApi.getDocumentsPaginated(fromDate, toDate, this.currentPage, this.pageSize, this.getDocumentTypes, this.sortBy, this.orderBy, companyBin, this.search, this.searchKey).then(resp => {
        this.totalElements = resp.total
        const railcarDataByDocumentId = {}
        this.data = resp.data.filter(item => {
          try {
            JSON.parse(item.data)
          } catch (e) {
            return false
          }
          return true
        }).map(item => {
          item.created = item.createdAt ? date.getFormattedDate(item.createdAt) : ''
          if (item.meta) {
            const docs = getAllDocuments()
            const ticks = getAllTickets()
            let documentsList = []
            for (const station in docs) {
              documentsList = documentsList.concat(docs[station])
              documentsList = documentsList.concat(ticks[station])
            }
            documentsList.forEach(doc => {
              if (doc.key === item.meta.doctype) {
                item.doctype = doc.title
              } else if (item.meta.doctype === 'vu20') {
                item.doctype = 'ВУ-20'
              } else if (item.meta.doctype === 'vu20a') {
                item.doctype = 'ВУ-20a'
              }
            })
          }
          if (item.status) {
            if (item.status.status === 'CREATED') {
              item.statusName = 'Создан'
            } else if (item.status.status === 'SENDED') {
              item.statusName = 'Отправлен'
            } else if (item.status.status === 'APPROVED') {
              item.statusName = 'Утвержден'
              if ((this.isRoleBatys || this.isRoleKazykurt || this.isRoleErtys) && (item.meta.doctype === 'vu20' || item.meta.doctype === 'vu20a')) {
                item.statusColor = 'warning'
              } else {
                item.statusColor = 'success'
              }
            } else if (item.status.status === 'RECEIVED') {
              item.statusName = 'Доставлен'
            } else if (item.status.status === 'REJECTED') {
              item.statusName = 'Отклонен'
              item.statusColor = 'danger'
            } else if (item.status.status === 'CANCELED') {
              item.statusName = 'Отменен'
              item.statusColor = 'danger'
            } else if (item.status.status === 'UPDATED') {
              item.statusName = 'Отредактирован'
            } else if (item.status.status === 'CONFIRMED') {
              item.statusName = 'Подтвержден'
              if ((this.isRoleBatys || this.isRoleKazykurt || this.isRoleErtys) && (item.meta.doctype === 'vu20' || item.meta.doctype === 'vu20a')) {
                item.statusColor = 'success'
              }
            }
          }
          if (item.data) {
            item.data = JSON.parse(item.data)
            const documentRailcar = item.data.body?.documentWorkplaceRailcar?.documentRailcar
            if (documentRailcar) {
              item.docNumber = documentRailcar.docNumber
              item.receiverCompany = documentRailcar.receiverCompany
              item.senderCompany = documentRailcar.senderCompany
              if (documentRailcar.attributeRequestsVu19) {
                item.action = this.formatAction(documentRailcar.attributeRequestsVu19.actionVu19)
              }
              if (item.meta) {
                railcarDataByDocumentId[item.meta.documentId] = {
                  docNumber: item.docNumber,
                  receiverCompany: item.receiverCompany,
                  senderCompany: item.senderCompany,
                  action: item.action
                }
              }
            }
          }
          return item
        })
        const uniqueItems = {}
        this.data.forEach(item => {
          if (!uniqueItems[item.meta.documentId] || uniqueItems[item.meta.documentId].createdAt < item.createdAt) {
            uniqueItems[item.meta.documentId] = item
          }
        })
        this.data = Object.values(uniqueItems).map(item => {
          if (!item.docNumber && railcarDataByDocumentId[item.meta.documentId]) {
            Object.assign(item, railcarDataByDocumentId[item.meta.documentId])
          }
          return item
        }).sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
        this.markNotificationsRead()
      }).catch(err => {
        console.log(err)
      }).finally(() => {
        this.isLoading = false
      })
    },
    formatAction (action) {
      if (!action) return ''
      if (Array.isArray(action)) {
        return action.map(x => (x && typeof x === 'object' ? x.title : x)).filter(Boolean).join(', ')
      }
      if (typeof action === 'object') return action.title || ''
      return action
    },
    markNotificationsRead () {
      if (this.isAllDocumentsView) return
      if (this.getDocumentTypes.length === 0) return
      documentNotificationsStore.markRead(this.getDocumentTypes)
    },
    createDocument () {
      this.$router.push('/company/create-ticket/' + this.creationDocType)
    },
    openDocument (data) {
      const docs = getAllDocuments()
      let documentsList = []
      for (const station in docs) {
        documentsList = documentsList.concat(docs[station])
      }
      const queryParams = {
        hash: data.hash
      }
      if (this.hasBinProps) {
        queryParams.bin = this.hasBinProps
      }
      if (data.meta.doctype === 'uborkaAfterGO' || data.meta.doctype === 'uborkaTorVrp' || data.meta.doctype === 'shunting') {
        this.$router.push({ path: '/company/create-ticket/' + data.meta.doctype, query: { hash: data.hash } })
      }
      if (documentsList.filter(i => i.key === data.meta.doctype || i.key.includes(data.meta.doctype)).length > 0) {
        this.$router.push({ path: '/company/documents-detail/' + data.meta.doctype, query: queryParams })
      } else {
        this.$router.push({ path: '/company/create-ticket/' + data.meta.doctype, query: { hash: data.hash } })
      }
    }
  }
}
</script>

<style>
.documents-page {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
}

.documents-page__filters {
  flex: 0 0 auto;
}

.documents-card {
  flex: 1 1 auto;
  min-height: 0;
  display: flex;
  flex-direction: column;
}

.documents-card > .el-card__body {
  flex: 1 1 auto;
  min-height: 0;
  display: flex;
  flex-direction: column;
}

.pagination {
  margin-top: 20px;
  flex: 0 0 auto;
  display: flex;
  justify-content: flex-end;
}
.el-table tr {
  cursor: pointer;
}
.el-table .error-row {
  background-color: #ffd8d8;
}
.el-table .canceled-row {
  background-color: #FCEBEB;
}
.table-container {
  flex: 1 1 auto;
  min-height: 0;
  overflow: hidden;
}

.page-subtitle {
  font-size: 13px;
  color: #7A8794;
  font-weight: 400;
  margin-left: 8px;
}

.filters-row {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}
.filters-row--second {
  margin-top: 12px;
}
.filters-row__date {
  flex: 1 1 260px;
}
.filters-row__select {
  width: 180px;
}
.filters-row__search {
  flex: 1 1 180px;
}

.pending-chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 14px;
  border-radius: 20px;
  border: 1px solid #E3A32A;
  background: #fff;
  color: #E3A32A;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
}
.pending-chip--active {
  background: #E3A32A;
  color: #1B222C;
}

.status-legend {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
  flex: 0 0 auto;
  margin-bottom: 16px;
  padding-bottom: 16px;
  border-bottom: 1px solid #DFE6ED;
}
.status-legend__icon {
  width: 18px;
  height: 18px;
  border-radius: 50%;
  border: 1px solid #7A8794;
  color: #7A8794;
  font-size: 11px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: default;
}
.status-legend__title {
  color: #7A8794;
  font-size: 13px;
  margin-right: 4px;
}
.status-legend__hint {
  color: #7A8794;
  font-size: 12px;
  margin-right: 10px;
}
</style>
